import { render } from "./RenewProfile.vue?vue&type=template&id=7e67bed8"
import script from "./RenewProfile.vue?vue&type=script&lang=js"
export * from "./RenewProfile.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\ssradius\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__